import React, { FC } from 'react';
import { formatDate } from 'utils/format';
import { TableCell, TableRow, Chip, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ActiveIndicator from 'components/users/shared/active-indicator/active-indicator.component';
import FormattedAddress from 'components/shared/address/formatted-address.component';
import { Clinic } from 'models/clinic';

type ClinicItemProps = {
    clinic: Clinic;
    onEditClinicClick: (clinic: Clinic) => void;
};
const ClinicItem: FC<ClinicItemProps> = ({ clinic, onEditClinicClick }: ClinicItemProps) => {
    const { t: translate } = useTranslation(['common', 'organization', 'client-directory']);
    const getClinicSubLabel = (clinic: Clinic): string => {
        if (!clinic.parentClinicId && !clinic.local && !clinic.isWhiteLabeled) {
            return translate(`client-directory:DENTHUB_CONNECTED`);
        }
        if (clinic.isWhiteLabeled) {
            return translate('client-directory:WHITE_LABEL');
        }
        if (clinic.local) {
            return translate('client-directory:MY_CLIENT');
        }

        if (clinic.parentClinicId && !clinic.local && !clinic.isWhiteLabeled) {
            return translate(`client-directory:DENTHUB_CONNECTED`);
        }
        return '';
    };

    return (
        <TableRow hover sx={{ cursor: 'pointer' }} onClick={() => onEditClinicClick(clinic)}>
            <TableCell sx={{ width: 10 }} align="center">
                <ActiveIndicator isActive={clinic.active} />
            </TableCell>
            <TableCell sx={{ width: 400 }}>
                <Box>{clinic.name}</Box>
                <Typography variant="caption" color="grey.500">
                    {clinic.officialName}
                </Typography>
            </TableCell>
            <TableCell>
                <Box>{clinic.organizationNumber}</Box>
            </TableCell>
            <TableCell>
                <Chip size="small" sx={{ cursor: 'pointer' }} label={getClinicSubLabel(clinic)} />
            </TableCell>
            <TableCell>
                <FormattedAddress address={clinic.contact?.address} oneLineFormat />
            </TableCell>
            <TableCell>{clinic.created?.on && <div>{formatDate(new Date(clinic.created.on), 'date')}</div>}</TableCell>
        </TableRow>
    );
};

export default ClinicItem;
